module.exports = __webpack_public_path__ + "static/media/8855.50d6f953.jpg";